// Header.js - Updated with improved language handling
import React from "react";
import { useSearchParams } from "react-router-dom";
import useLanguage from "hooks/useLanguage"; // Import the custom hook
import { Globe, MenuIcon, X } from "lucide-react";

interface HeaderProps {
  isMenuOpen?: boolean;
  toggleMenu?: () => void;
  closeMenu?: () => void;
}

const Header = ({ isMenuOpen = false, toggleMenu, closeMenu }: HeaderProps) => {
  const [searchParams] = useSearchParams();
  const pageTitleFromParams = searchParams.get("pageTitle") || "";

  // Use the custom language hook
  const { toggleLanguage, alternativeLanguage, alternativeLanguageLabel } =
    useLanguage();

  return (
    <div className="py-3 px-4 md:py-4 md:px-8 flex justify-between items-center border-b shadow-sm sticky top-0 w-full bg-white z-20">
      <div className="flex items-center gap-4">
        {/* Mobile Menu Toggle - Integrated in header */}
        {toggleMenu && (
          <button
            className="md:hidden p-2 hover:bg-gray-100 transition-colors duration-200 rounded-lg"
            onClick={() => {
              if (isMenuOpen && closeMenu) {
                closeMenu();
              } else if (toggleMenu) {
                toggleMenu();
              }
            }}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? (
              <X size={20} className="text-gray-700" />
            ) : (
              <MenuIcon size={20} className="text-gray-700" />
            )}
          </button>
        )}

        <span className="text-lg md:text-xl font-semibold text-gray-800 truncate">
          {pageTitleFromParams}
        </span>
      </div>

      {/* Language Switcher - Desktop Only */}
      <button
        onClick={toggleLanguage}
        className="hidden md:flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-50 transition-all duration-200 rounded-lg border border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md min-w-[60px] justify-center"
        title={`Switch to ${alternativeLanguageLabel}`}
      >
        <Globe size={16} />
        <span className="text-sm font-medium">{alternativeLanguage}</span>
      </button>
    </div>
  );
};

export default Header;
